import { AppEvent } from 'app-shared/kmc-shared/app-events/app-event';
import { KalturaMediaEntry, KalturaPlaylist } from 'kaltura-ngx-client';

export class PreviewAndEmbedEvent extends AppEvent {
  constructor(public media: KalturaPlaylist | KalturaMediaEntry) {
    super('PreviewAndEmbedEvent');
  }
}
